import { Button, Dialog, DialogContent, Divider, Grid, makeStyles, Paper, TextField, Toolbar, Typography } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import ClearIcon from "@material-ui/icons/Clear";
import MandatorySpan from "../../../common/sasl/models/MandatorySpan";
import { ChevronRight } from '@material-ui/icons';
import axios from 'axios';
import { smlUrl } from '../../../../../../utils/config';
import jwtDecode from 'jwt-decode';
import { DESTROY_BACKDROP, OPEN_BACKDROP } from '../../../../containers/actions/types';
import { useDispatch } from 'react-redux';
import BackDropLoading from '../../../common/models/BackDrop';

const useStyles = makeStyles((theme) => ({
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  header: {
    textAlign: "center",
  },
  flexGrow: {
    flexGrow: 1,
  },
  textFieldSty: {
    '& input.MuiInputBase-input.MuiOutlinedInput-input': {
      paddingTop: '10px',
      paddingBottom:'10px'
    }
  },
  closeText: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: 500,
    "&:hover": {
      borderBottom: "2px solid red",
    },
  }
}));

const BatchAllocationElectronicSignature = (props) => {
  const { open, onClose, allocationDetails, handleESignatureSuccess } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
    
  const tokenData = jwtDecode(localStorage.getItem('authToken'));

  const [teamMemberId, setTeamMemberId] = useState(tokenData?.email_address || '');
  const [password, setPassword] = useState('');
  const [comments, setComments] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpToken, setOtpToken] = useState('');

  const [errors, setErrors] = useState({ 
    error: false, 
    userID:'', 
    password:'',
    comments: '',
    otp: ''
  });

  // Reset OTP state when dialog opens
  useEffect(() => {
    if (open) {
      setOtpSent(false);
      setOtp('');
      setOtpToken('');
      setPassword('');
      setComments('');
      setErrors({ 
        error: false, 
        userID:'', 
        password:'',
        comments: '',
        otp: ''
      });
    }
  }, [open]);

  const handleGetOTP = () => {
    // Reset errors
    let newErrors = { error: false, userID: '', password: '', comments: '', otp: '' };
    let hasError = false;

    // Validation for email
    if (teamMemberId === '') {
      newErrors.userID = 'Please enter User Email';
      hasError = true;
    } else if (teamMemberId !== tokenData.email_address) {
      newErrors.userID = 'Please enter valid User Email';
      hasError = true;
    }

    // Comments are mandatory for rejection
    if (allocationDetails.decision === 'Reject' && comments.trim() === '') {
      newErrors.comments = 'Comments are mandatory for rejection';
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    const otpPayload = {
      email: teamMemberId,
      purpose: 'allocation_signature'
    };
    
    dispatch({
      type: OPEN_BACKDROP,
    });

    axios
      .post(`${smlUrl}/user/sendOTP`, otpPayload)
      .then((res) => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        if (res.data.status === true) {
          setOtpSent(true);
          setOtpToken(res.data.data.otpToken);
          setErrors({ ...errors, error: false });
        } else {
          setErrors({...errors, error: true});
        }
      })
      .catch((err) => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setErrors({...errors, error: true});
      });
  };

  const handleVerifyOTP = () => {
    // Reset errors
    let newErrors = { error: false, userID: '', password: '', comments: '', otp: '' };
    let hasError = false;

    // Validation for OTP
    if (otp === '') {
      newErrors.otp = 'Please enter OTP';
      hasError = true;
    }

    // Comments are mandatory for rejection
    if (allocationDetails.decision === 'Reject' && comments.trim() === '') {
      newErrors.comments = 'Comments are mandatory for rejection';
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    const verifyPayload = {
      email: teamMemberId,
      otpValue: otp,
      otpToken: otpToken
    };
    
    dispatch({
      type: OPEN_BACKDROP,
    });

    axios
      .post(`${smlUrl}/user/verifyOTP`, verifyPayload)
      .then((res) => {
        if (res.data.status === true) {
          handleESignatureSuccess('electronicSignSuccess', comments);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setErrors({...errors, error: true, otp: res.data.message || 'Invalid OTP'});
        }
      })
      .catch((err) => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setErrors({...errors, error: true, otp: 'Failed to verify OTP'});
      });
  };

  const handleVerifyUser = () => {
    // Reset errors
    let newErrors = { error: false, userID: '', password: '', comments: '' };
    let hasError = false;

    // Validation
    if (teamMemberId === '') {
      newErrors.userID = 'Please enter User Email';
      hasError = true;
    } else if (teamMemberId !== tokenData.email_address) {
      newErrors.userID = 'Please enter valid User Email';
      hasError = true;
    }

    if (password === '') {
      newErrors.password = 'Please enter password';
      hasError = true;
    }

    // Comments are mandatory for rejection
    if (allocationDetails.decision === 'Reject' && comments.trim() === '') {
      newErrors.comments = 'Comments are mandatory for rejection';
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    const signInData = {
      email: teamMemberId,
      password: password,
    };
    
    dispatch({
      type: OPEN_BACKDROP,
    });

    axios
      .post(`${smlUrl}/user/verifyPassword`, signInData)
      .then((res) => {
        if (res.data.status === true) {
          handleESignatureSuccess('electronicSignSuccess', comments);
          dispatch({
            type: DESTROY_BACKDROP,
          });
        } else {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setErrors({...errors, error: true, password:'Please enter valid password'});
        }
      })
      .catch((err) => {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        setErrors({...errors, error: true});
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose} 
      fullWidth 
      maxWidth="lg"
      disableBackdropClick
      disableEscapeKeyDown
    >
      <BackDropLoading />
      <Paper style={{ padding: '1.5rem' }}>
        <Toolbar className={classes.header}>
          <Typography style={{fontWeight:500, fontSize:'2rem'}} className={classes.flexGrow}>
            Complete electronic signature
          </Typography>
          <div className={classes.closeText} onClick={onClose}>
            <Typography variant="body2" style={{ fontWeight:500, cursor: "pointer" }}>
              Cancel 
            </Typography>
            <ClearIcon style={{color:'#FF0000'}} />
          </div>
        </Toolbar>
        
        {errors.error && (
          <Grid container item alignItems="center" justifyContent="center">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "50px",
                border: "2px solid #FF0000",
                backgroundColor: "#FFF0F0",
                width: "50%",
              }}
            >
              <Typography style={{ textAlign: "center" }}>
                Something went wrong. Please try again.
              </Typography>
            </div>
          </Grid>
        )}
        
        <DialogContent>
          <Typography variant="h6" style={{ fontSize:'1.5rem', fontWeight: 500 }}>Declaration</Typography>
          <hr className={classes.hrLine} />
          <Typography style={{ margin: '1rem 0' }}>
            I, {tokenData.full_name}, am {allocationDetails.decision === 'Approve' ? 'approving' : 'rejecting'} the component allocation for PO {allocationDetails?.poNumber || ''}.
          </Typography>

          {/* Comments field - mandatory for rejection */}
          {allocationDetails.decision === 'Reject' && (
            <Grid container style={{ marginBottom: '1rem' }}>
              <Grid item xs={12}>
                <Typography style={{ fontWeight: 500, marginBottom: '5px' }}>
                  Comments <MandatorySpan/>
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Rejecting for this and this reason."
                  value={comments}
                  onChange={(e) => {
                    setComments(e.target.value);
                    setErrors({ ...errors, comments: '' });
                  }}
                  error={!!errors.comments}
                  helperText={errors.comments}
                  multiline
                  rows={2}
                />
              </Grid>
            </Grid>
          )}

          <Divider style={{ backgroundColor:'gray', margin: '2rem 0' }} />

          <Typography variant="h6" style={{ fontSize:'1.5rem',fontWeight: 500 }}>Electronic Signature</Typography>
          <hr className={classes.hrLine} />
          <Grid container>
            <Grid item xs={6}>
              <Typography style={{ fontWeight: 500 }}>Name</Typography>
              <Typography>{tokenData.full_name}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography style={{ fontWeight: 500 }}>Department-role</Typography>
              <Typography>{localStorage.getItem("departmentName")} - {tokenData.role_name}</Typography>
            </Grid>
          </Grid>
          <Divider style={{ backgroundColor:'gray', margin: '2rem 0' }} />

          <Typography variant="h6" style={{ fontSize:'1.5rem', fontWeight: 500 }}>Confirm Signature</Typography>
          <hr className={classes.hrLine} />
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography style={{fontWeight: 500, marginBottom:'5px'}}>
                User Email <MandatorySpan/>
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                required
                className={classes.textFieldSty}
                placeholder="User Email"
                value={teamMemberId}
                onChange={(e) => {
                  setErrors({ ...errors, userID:'', password:'', otp:''});
                  setTeamMemberId(e.target.value);
                }}
                error={!!errors.userID}
                helperText={errors.userID}
                disabled={otpSent}
              />
            </Grid>
            {!otpSent && (
              <Grid item xs={2}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ borderRadius: "20px", textTransform: "none", marginTop: '29px' }}
                  onClick={handleGetOTP}
                >
                  Get OTP
                </Button>
              </Grid>
            )}
            {otpSent && (
              <>
                <Grid item xs={3}>
                  <Typography style={{fontWeight: 500, marginBottom:'5px'}}>
                    Enter OTP sent to User Email <MandatorySpan/>
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    required
                    className={classes.textFieldSty}
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => {
                      setErrors({ ...errors, otp: '' });
                      setOtp(e.target.value);
                    }}
                    error={!!errors.otp}
                    helperText={errors.otp}
                    type="password"
                  />
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ borderRadius: "20px", textTransform: "none", marginTop: '29px' }}
                    onClick={handleVerifyOTP}
                  >
                    Confirm OTP
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
      </Paper>
    </Dialog>
  );
};

export default BatchAllocationElectronicSignature;
